import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { NmDatatableSettings } from '../../../../widgets/datatable/datatable.interface';
import { DataService } from '../../../../services/data.service';
import { FormService } from '../../../../services/form.service';
import { ApiService } from '../../../../services/api.service';
import * as moment from 'moment';

declare let bootbox: any;
declare let $: any;

@Component({
	selector: 'schools-detail-tab-view',
	templateUrl: './tab-view.html'
})
export class SchoolsDetailTabView implements OnInit {

	@Input() form: FormGroup;
	@Input() id: string|number;
	public _reloadTable: boolean;

	private _partFormData = null;
	@Input()
	set partFormData(partFormData: any){
		if(partFormData){
			this.patchPartFormValue(partFormData);
		}else{
			this.partform.reset();
		}
		this._partFormData = partFormData;
	}
	get partFormData(): any{
		return this._partFormData;
	}

	public partform: FormGroup = this.formBuilder.group({
		// basic information
	  //YFSID: [{value: '', disabled: true}],
	  MembershipYear: ['',Validators.required],
	  TotalSchoolMembers: ['',Validators.required],
		
	});

	@Input()
	set reloadTable(reloadTable: boolean){
		this._reloadTable = reloadTable;
		
	}
	get reloadTable(): boolean{ return this._reloadTable}
	
	public constructor(
		private data: DataService,
		private router: Router,
		public formBuilder: FormBuilder,
		public _form: FormService,
		private activedRoute: ActivatedRoute,
		private api: ApiService,
	) {}

	public ngOnInit() {
		this.participationSettings.ajax.url = 'school/'+this.id+'/participationtables';
		this.teacherSettings.ajax.url = 'school/'+this.id+'/teachertables';
		setTimeout(function(){
			$('.editpartform input').prop('disabled',false);
			$('.editpartform input').css({ 'cursor': 'default', 'pointer-events': '' });
		},2000)
		this._form.setForm(this.partform);
	}

	public ngAfterViewInit() {
		this.form.valueChanges.subscribe(() => {
			//this._updateBuProfiles(this.form.get('partner_profiles').value);
		});
	}

	public patchPartFormValue(partFormData) {
		console.log(this.partFormData);
		this.partform.patchValue(partFormData);
	}

	public participationSettings: NmDatatableSettings = {
		modelName: 'school',
		fields: [
			{ name: 'MembershipYear', label: 'Membership Year' },
			{ name: 'TotalSchoolMembers', label: 'Total School Members' },
			{ name: 'TotalIndividualMembers', label: 'Total Individual Members' },
		],
		actions: [
			{ name: 'edit', icon: 'edit',  show: () => true , callback: function(id: string, data: any): void {
				this.dataService.tmpData.selectedEditPartRecord = data;
			
		}},
		{ name: 'delete', icon: 'trash', color: 'red', show: () => true , callback: function(id: string, data: any): void {
			bootbox.confirm('Are you sure to delete this record?', (ok) => {
				if(ok) {
					this.dataService[this.settings.modelName].participationdelete(id)
					.then(() => this.reload());
				}
			});
		}}
		],
		ajax: {
			url: 'school/undefined/participationtables'
		},
		ajaxDataMassage: (data: any[]) => {
			if (data == undefined) return [];
			return data.map(v => {
				
				v.id = v.ParticipationRecordId;
				

				return v;
			})
		}
	};


	public teacherSettings: NmDatatableSettings = {
		modelName: 'teacher',
		fields: [
			{ name: 'Salutation', label: 'Salutation', sortable: false, searchable: true, },
			{ name: 'Name', label: 'Name (English)', sortable: false, searchable: true, },
			{ name: 'NameChinese', label: 'Name (Chinese)', sortable: false, searchable: true, },
			{ name: 'SchoolId', label: 'School ID', sortable: false, searchable: true, },
			{ name: 'SchoolName', label: 'School Name', sortable: false, searchable: true, },
			//{ name: 'NameChinese', label: 'Name (Chinese)', sortable: false, searchable: true, },
			{ name: 'JobPosition', label: 'Position / Title', sortable: false, searchable: true, },
			{ name: 'SubjectsTaught', label: 'Subjects taught / Department', sortable: false, searchable: true, },
			{ name: 'Telephone1', label: 'Tel (Office)', sortable: false, searchable: true, },
			{ name: 'Telephone2', label: 'Tel (Mobile)', sortable: false, searchable: true, },
			{ name: 'Fax', label: 'Fax', sortable: false, searchable: true, },
			{ name: 'EmailAddress1', label: 'Email (Work)', sortable: false, searchable: true, },
			{ name: 'EmailAddress2', label: 'Email (Personal)', sortable: false, searchable: true, },
			{ name: 'InCharge', label: 'YFS Teacher in charge', sortable: false, searchable: true, },
			
			
		],
		actions: [
			{ name: 'view', icon: 'search-plus', color: 'blue', show: () => true,
				callback: function(id, data) { this.router.navigate([`/teachers/view/${id}`]); }
			},
			{ name: 'edit', icon: 'pencil', color: 'green', show: () => true,
				callback: function(id, data) { this.router.navigate([`/teachers/edit/${id}`]); }
			},
			{ name: 'delete', icon: 'trash', color: 'red', show: () => true },
		],
		ajax: {
			url: 'teacher/datatables'
		},
		ajaxDataMassage: (data: any[]) => {
			
			return data.map(v => {
				
				v.id = v.TeacherId;
				v.InCharge = (v.InCharge == '1' ? 'Yes' : 'No');
				v.SchoolName = (v.school ? v.school.SchoolCompleteName : '');

				return v;
			})
		}
	};


	public onBeforeSubmit(data: any): any { return data; }
	
		// after submit handle
		// default show bootbox and then return to previous page
		// note that default submission failure handle
		// should be the resposibility of api dependency of data.service 
		// override this if special handle is required
		public onAfterSubmit(success: boolean): void {
			if(success) {
				bootbox.alert({
					message: 'success',
					callback:() => {
						this.onAfterSubmitAlertCallback();
					}
				});
			}
		};
	
		// callback for alert prompt after submit
		// override this if special handle is required
		public onAfterSubmitAlertCallback(): void {
			this.data.tmpData.selectedEditPartRecord = null;
		}
	
		// validation handle
		// default using form service to show error prompt
		// override this if special handle is required
		public onValidationFail(): void {
			this._form.showErrors();
		};
	
		// default submit handle
		// override this if special handle is required
		public onSavePartForm(): void {

			this._form.setForm(this.partform);
			
			let data = JSON.parse(JSON.stringify(this.partform.value)); // copy
	
			data.SchoolId = this.id;
			if(this.onBeforeSubmit) {
				data = this.onBeforeSubmit(data);
			}
			//console.log(data);
	
			// stop from page
			if(data === false)
				return;
	
			if(this.partform.valid) {
				try {
					let promise;
					promise = this.api.sendApiRequest('post', 'school/'+this.data.tmpData.selectedEditPartRecord.ParticipationRecordId+'/edit', data).toPromise();
					
	
					promise
					.then(res => {
						this.onAfterSubmit(true);
					})
					.catch(err => {
						this.onAfterSubmit(false);
					});
				}
				catch(e) {
					console.error(e);
				}
			}
			else {
				this.onValidationFail();
			}
		}

}


// WEBPACK FOOTER //
// ./src/pages/schools/detail/tab-view/tab-view.ts